// src/components/About.js
import React from "react";
// import about from "../assets/img/about/about-1.webp";
// import cart1 from "../../assets/img/cart/cart1.JPEG";
// import cart1 from "../../assets/img/cart/IMG_0063.JPEG";
import cart1 from "../../assets/img/cart/IMG_0063_copy.JPEG";

const Mission = () => {
  return (
    <div>
      <div className="bg-secondary-subtle">
        <div className=" ">
          <div
            className="py-5 section px-4 pb-2"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="container">
              <div className=" section-title p-1" data-aos="fade-up">
                <span className="subtitle">Mission</span>
                {/* <h3>WE DESIGN & MANUFACTURE</h3> */}
              </div>
              <div className="row  items-start">
                <div
                  className="col-lg-6  "
                  data-aos="fade-left"
                  data-aos-delay="300"
                >
                  <div
                    className="w-full lg:w-[70%] py-10"
                    data-aos="fade-left"
                    data-aos-delay="300"
                    // style={{ height: "400px", maxHeight: "100%" }} // fixed or responsive height on container
                  >
                    <div className="overflow-hidden rounded-lg shadow-lg transform transition duration-300 hover:scale-105 h-full">
                      <img
                        src={cart1}
                        alt="Sustainable Coffee Bike"
                        className="w-full h-full object-contain p-4"
                      />
                    </div>
                  </div>
                </div>
                {/* Text Content */}
                <div className="col-lg-6 flex flex-col items-start justify-start text-left  italic leading-7 md:text-xl">
                  <div
                    className="w-[60px] h-[60px] flex items-center justify-center rounded-full mb-6 text-[1.75rem]"
                    style={{
                      backgroundColor:
                        "color-mix(in srgb, #c85716, transparent 90%)",
                      color: "#c85716",
                    }}
                  >
                    <i className="bi bi-quote"></i>
                  </div>
                  <p>
                    At CART STUDIO, our mission is to evolve as a global
                    enterprise that fulfills our customers’ needs and
                    aspirations for mobility. We are committed to setting new
                    benchmarks in technology, design, and quality, while
                    consistently delivering value and ensuring customer
                    satisfaction. With a strong focus on innovation and
                    sustainability, we strive to create solutions that not only
                    drive progress but also contribute meaningfully towards
                    sustainable development and a cleaner future.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
